<template lang="pug">
  div
    p.title Filtros
    div(v-if="!isFiltroProcesso")
      el-row.labelDiv(type='flex')
        el-col.inputDiv(:span="8").container-input.mb
          app-label(label="Ordem de serviço", :required="false")
          el-select.input(
            multiple
            collapse-tags
            filterable
            class="select"
            v-model="filtroOs.ordensServico"
            placeholder="Selecione"
            value-key="id"
          )
            el-option.selectOs(
              v-for="os in osList",
              :key="os.id",
              :label="os.numero",
              :value="os.id"
          )
        el-col.inputDiv(:span="8").container-input.mb
          app-label(label="Técnico de campo", :required="false")
          el-select.input(
            multiple
            collapse-tags
            filterable
            class="select"
            v-model="filtroOs.tecnicosCampo"
            placeholder="Selecione"
            value-key="id"
          )
            el-option.selectText(
              v-for="tecnicoDeCampo in tecnicoDeCampoList",
              :key="tecnicoDeCampo.id",
              :label="tecnicoDeCampo.pessoa.pessoaFisica.nome",
              :value="tecnicoDeCampo.id"
            )
        el-col.inputDiv(:span="8").container-input.mb
          app-label(label="Período referente à criação da OS", :required="false")
          el-date-picker(
            v-model="filtroOs.periodoInsercao"
            type="daterange"
            unlink-panels
            range-separator="até"
            start-placeholder="Início"
            end-placeholder="Fim"
            format="dd/MM/yyyy"
            :picker-options="pickerOptions"
          )
      el-row.labelDiv(type='flex')
        el-col.inputDiv(:span="8").container-input
          app-label(label="Tipo de processo", :required="false")
          el-select.input(
            multiple
            collapse-tags
            filterable
            class="select"
            v-model="filtroOs.tiposProcesso"
            placeholder="Selecione"
            value-key="id"
          )
            el-option(
              v-for="tipoProcesso in tipoProcessoList",
              :key="tipoProcesso.codigo",
              :label="tipoProcesso.nome",
              :value="tipoProcesso.codigo"
          )
        el-col.inputDiv(:span="8").container-input
          app-label(label="Município", :required="false")
          el-select.input(
            multiple
            collapse-tags
            filterable
            class="select"
            v-model="filtroOs.municipios"
            placeholder="Selecione"
            value-key="id"
          )
            el-option(
              v-for="municipio in municipioList",
              :key="municipio.id",
              :label="municipio.label",
              :value="municipio.id"
          )
        el-col(:span="8").container-input
    div(v-else)
      el-row.labelDiv(type='flex')
        el-col.inputDiv(:span="8").container-input.mb
          app-label(label="Número do processo", :required="false")
          el-input.input(
            class="select"
            v-model="filtroProcesso.numeroProcesso"
            v-mask="['#########/####']"
          )
        el-col.inputDiv(:span="8").container-input.mb
          app-label(label="Ordem de serviço", :required="false")
          el-select.input(
            collapse-tags
            multiple
            filterable
            class="select"
            v-model="filtroProcesso.listIdOrdemServico"
            placeholder="Selecione"
            value-key="id"
          )
            el-option.selectOs(
              v-for="os in osList",
              :key="os.id",
              :label="os.numero",
              :value="os.id"
            )
        el-col.inputDiv(:span="8").container-input.mb
          app-label(label="Município", :required="false")
          el-select.input(
            collapse-tags
            multiple
            filterable
            class="select"
            v-model="filtroProcesso.listIdMunicipio"
            placeholder="Selecione"
            value-key="id"
          )
            el-option(
              v-for="municipio in municipioList",
              :key="municipio.id",
              :label="municipio.label",
              :value="municipio.id"
            )
      el-row.labelDiv(type='flex')
        el-col.inputDiv(:span="8").container-input.mb
          app-label(label="Situação", :required="false")
          el-select.input(
            collapse-tags
            multiple
            filterable
            class="select"
            v-model="filtroProcesso.listCodigoSituacao"
            placeholder="Selecione"
            value-key="id"
          )
            el-option.selectGeral(
              v-for="situacao in situacaoList",
              :key="situacao.codigo",
              :label="situacao.codigo === 'AGUARDANDO_ANALISE_PROCESSO_PAI' ? 'Aguardando processo chegar para o Técnico de campo' : situacao.nome",
              :value="situacao.codigo"
            )
        el-col.inputDiv(:span="8").container-input.mb
          app-label(label="Técnico de campo", :required="false")
          el-select.input(
            collapse-tags
            multiple
            filterable
            class="select"
            v-model="filtroProcesso.listIdTecnicosCampo"
            placeholder="Selecione"
            value-key="id"
          )
            el-option.selectText(
              v-for="tecnicoDeCampo in tecnicoDeCampoList",
              :key="tecnicoDeCampo.id",
              :label="tecnicoDeCampo.pessoa.pessoaFisica.nome",
              :value="tecnicoDeCampo.id"
            )
        el-col.inputDiv(:span="8").container-input.mb
          app-label(label="Tipo de processo", :required="false")
          el-select.input(
            collapse-tags
            multiple
            filterable
            class="select"
            v-model="filtroProcesso.listIdTipoCadastro"
            placeholder="Selecione"
            value-key="id"
          )
            el-option(
              v-for="tipoProcesso in tipoProcessoList",
              :key="tipoProcesso.id",
              :label="tipoProcesso.nome",
              :value="tipoProcesso.id"
            )
      el-row.labelDiv(type='flex')
        el-col.inputDiv(:span="8").container-input.mb
          app-label(label="Nome do interessado", :required="false")
          el-select.input(
            collapse-tags
            multiple
            filterable
            class="select"
            v-model="filtroProcesso.listCpfInteressado"
            placeholder="Selecione"
            value-key="id"
          )
            el-option.selectInteressado(
              v-for="interessado in interessadoList",
              :key="interessado.cpf",
              :label="interessado.nome",
              :value="interessado.cpf"
            )
        el-col.inputDiv(:span="8").container-input.mb
          app-label(label="Período referente à criação da OS", :required="false")
          el-date-picker(
            v-model="filtroProcesso.periodoInsercao"
            type="daterange"
            unlink-panels
            range-separator="até"
            start-placeholder="Início"
            end-placeholder="Fim"
            format="dd/MM/yyyy"
            :picker-options="pickerOptions"
          )
        el-col(:span="8").container-input.mb
    .container-pesquisa
      .button-pesquisa
        el-button(type="text" @click="resetPesquisa")
          | Limpar
        el-button(type="primary" @click="pesquisar")
          i.fal.fa-search
          | &nbsp Pesquisar

</template>

<script>
import AppLabel from '@/components/AppLabel'
import { mapActions } from 'vuex'
import moment from 'moment'

const UMA_SEMANA = new Date().getTime() - 3600 * 1000 * 24 * 7
const UM_MES = new Date().getTime() - 3600 * 1000 * 24 * 30
const TRES_MESES = new Date().getTime() - 3600 * 1000 * 24 * 90
const HOJE = new Date().getTime()
const UM_ANO = new Date().getTime() - 3600 * 1000 * 24 * 365

export default {
  components: {
    AppLabel
  },
  props: {
    isFiltroProcesso: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      osList: [],
      tecnicoDeCampoList: [],
      tipoProcessoList: [],
      municipioList: [],
      situacaoList: [],
      listIdTecnicosCampo: [],
      interessadoList: [],

      filtroOs: {
        ordensServico: [],
        tecnicosCampo: [],
        periodoInsercao: [UM_ANO, HOJE],
        dataInicio: moment(UM_ANO).format('DD/MM/YYYY'),
        dataFim: moment(HOJE).format('DD/MM/YYYY'),
        tiposProcesso: [],
        municipios: [],
        tamanhoPagina: 20
      },

      filtroProcesso: {
        numeroProcesso: '',
        listIdOrdemServico: [],
        listIdMunicipio: [],
        listCodigoSituacao: [],
        listIdTecnicosCampo: [],
        listIdTipoCadastro: [],
        listCpfInteressado: [],
        periodoInsercao: [UM_ANO, HOJE],
        periodoInicial: moment(UM_ANO).format('DD/MM/YYYY'),
        periodoFinal: moment(HOJE).format('DD/MM/YYYY')
      },

      pickerOptions: {
        shortcuts: [{
          text: 'Última semana',
          onClick (picker) {
            const end = new Date()
            const start = UMA_SEMANA
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Último mês',
          onClick (picker) {
            const end = new Date()
            const start = UM_MES
            picker.$emit('pick', [start, end])
          }
        }, {
          text: 'Últimos 3 meses',
          onClick (picker) {
            const end = new Date()
            const start = TRES_MESES
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },

  methods: {
    ...mapActions({
      getMunicipios: 'relatoriosOs/getMunicipios',
      getOs: 'relatoriosOs/getOs',
      getTiposProcessos: 'relatoriosOs/getTiposProcessos',
      getTecnicosDeCampo: 'relatoriosOs/getTecnicosDeCampo',
      getSituacao: 'relatoriosOs/getSituacao',
      getGeomensor: 'relatoriosOs/getGeomensor',
      getVistoriador: 'relatoriosOs/getVistoriador',
      getInteressado: 'relatoriosOs/getInteressado'
    }),

    resetPesquisa () {
      this.isFiltroProcesso
        ? this.filtroProcesso = {
          listIdNumeroProcesso: [],
          listIdOrdemServico: [],
          listIdMunicipio: [],
          listCodigoSituacao: [],
          listIdTecnicosCampo: [],
          listIdTipoCadastro: [],
          listCpfInteressado: [],
          periodoInsercao: [UM_ANO, HOJE],
          periodoInicial: moment(UM_ANO).format('DD/MM/YYYY'),
          periodoFinal: moment(HOJE).format('DD/MM/YYYY'),
          pagina: 0
        }
        : this.filtroOs = {
          ordensServico: [],
          tecnicosCampo: [],
          periodoInsercao: [UM_ANO, HOJE],
          dataInicio: moment(UM_ANO).format('DD/MM/YYYY'),
          dataFim: moment(HOJE).format('DD/MM/YYYY'),
          tiposProcesso: [],
          municipios: [],
          pagina: 0
        }

      this.pesquisar()
    },
    pesquisar () {
      this.isFiltroProcesso
        ? this.$emit('search', this.filtroProcesso)
        : this.$emit('search', this.filtroOs)
    }
  },

  mounted: function () {
    this.getMunicipios().then((municipios) => {
      this.municipioList = municipios.sort((a, b) => {
        return a.label.trim().localeCompare(b.label.trim())
      })
    })

    this.getOs().then((os) => {
      this.osList = _.orderBy(os, ['numero'], ['asc']) // eslint-disable-line
    })

    this.getTiposProcessos().then((tipo) => {
      this.tipoProcessoList = tipo.sort((a, b) => {
        return a.nome.trim().localeCompare(b.nome.trim())
      })
    })

    this.getTecnicosDeCampo().then((tecnico) => {
      this.tecnicoDeCampoList = tecnico.sort((a, b) => {
        return a.pessoa.pessoaFisica.nome.trim().localeCompare(b.pessoa.pessoaFisica.nome.trim())
      })
    })

    this.getSituacao().then((situacao) => {
      this.situacaoList = _.orderBy(situacao, ['nome'], ['asc']) // eslint-disable-line
    })

    this.getInteressado().then((interessado) => {
      this.interessadoList = interessado.sort((a, b) => {
        return a.nome.trim().localeCompare(b.nome.trim())
      })
    })
  },

  watch: {
    'filtroOs.periodoInsercao' (val) {
      this.filtroOs.dataInicio = moment(val[0]).format('DD/MM/YYYY')
      this.filtroOs.dataFim = moment(val[1]).format('DD/MM/YYYY')
    },

    'filtroProcesso.periodoInsercao' (val) {
      this.filtroProcesso.periodoInicial = moment(val[0]).format('DD/MM/YYYY')
      this.filtroProcesso.periodoFinal = moment(val[1]).format('DD/MM/YYYY')
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.container-input {
  margin-right: 20px;
  margin-top: 0px;
  margin-bottom: 10px;
}

.select {
  width: 100%;
}

.el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.el-date-editor >>> .el-range-separator {
  width: 20%;
}

.el-date-editor >>> .el-picker-panel__body {
  margin-left: 130px;
}

.el-date-editor
  >>> .el-picker-panel__body-wrapper
  >>> .el-picker-panel__sidebar {
  width: 130px;
}

.container-pesquisa {
  padding: 0px 10px 0px 0px;
  display: flex;
  flex-direction: column;
  :first-child {
    margin-right: 10px;
  }
  .button-pesquisa {
    margin-top: 20px;
    align-self: flex-end;
  }
}
.title {
  margin-bottom: 15px !important;
}
.mb {
  margin-bottom: 2%;
}

@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 100%;
  }

  .selectOs {
    position: relative;
    left: 85px !important;
  }
  .selectText {
    position: relative;
    left: 55px;
  }

  .selectGeral {
    position: relative;
    left: 25px;
  }

  .selectInteressado {
    position: relative;
    left: 185px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/os/Filtro.vue